import { chaosNotify, chaosInput, popToast } from './utils/alerts.js';
import { escapeHtml, formatSmartDate, formatTime, convertirRaccourcisEnEmojis } from './utils/formatters.js';
import { state } from './core/state.js';
import { i18n, t } from './core/i18n.js';
import { socket } from './core/socket.js';
import { initTwemojiPickers } from './core/twemoji-setup.js';
import {
    naviguer, appliquerNavigation, clicSurSphere,
    majVisibiliteBandeauAppel, majVisibiliteRecherche,
    toggleMobileChannels, toggleMobileAgents, toggleMobileSettings,
    closeMobileOverlays, syncMobileOverlay
} from './ui/navigation.js';
import {
    connexion, deconnexion, procederInscription, validerSetupGoogle,
    ouvrirModalReset, fermerModalReset, validerResetPass,
    valider2FALogin, annuler2FALogin, lancer2FASetup, confirmer2FASetup,
    copierCodesSecours, fermer2FASetup, ouvrirDesactiver2FA, confirmerDesactiver2FA,
    majUI2FA, consommerInviteEnAttente, getCookie
} from './auth/auth.js';
import {
    ouvrirModalReport, fermerModalReport, validerReport,
    toggleModerationPanel,
    actionModoRejeter, actionModoAvertir, actionModoSupprimer,
    ouvrirModalMute, fermerModalMute, validerMute,
    ouvrirModalBootstrap, fermerModalBootstrap, validerBootstrap,
    envoyerChangelog,
    toggleSettings, fermerSettings,
    ouvrirParamsAvances, fermerParamsAvances, switchParamsSection,
    NOTIF_DEFAULTS, chargerPrefsNotif, sauvegarderPrefNotif, getNotifPref
} from './ui/modals.js';
import {
    toggleSidebarMenu, majPushChannels, toggleAgents,
    rechercherAgent, fermerModaleRecherche, toggleRequestInbox, ouvrirSphereSociale,
    startScramble,
    ouvrirModaleChoix, ouvrirCreationDirecte, ouvrirRejoindreDirecte, fermerToutesModales,
    envoyerCodeInvitation, construireLienInvitation, copierCode, copierLienInvitation,
    chargerDossiers, _saveDossiers, _setOrdreSpheres,
    creerDossier, retirerDuDossier, toggleDossier, ouvrirMenuDossier, renommerDossierCtx,
    changerCouleurDossier, dissoudreDossierCtx, ouvrirGestionnaireTags,
    fermerGestionnaireTags, validerAjoutTag, initSidebarSync, _setSphereContexte,
    rendreListeSpheres, hookSpheresSockets , genererLien
} from './ui/sidebar.js';
import {
    scrollToBottom,
    toggleEmojiPicker, toggleGifPicker, toggleCustomEmojiPicker, emojiGifTab, toggleEmojiGif,
    repondre, annulerReponse, toggleReplyMention, commencerEdition, annulerEdition,
    getReponseEnCours, getEditionEnCours,
    ouvrirMenuReaction, envoyerReaction, ouvrirFullEmoji, ouvrirFullEmojiDepuisBtn,
    construireReactionsMessage, setReactionMessageId,
    toggleMenuAjout, fermerMenuAjout,
    fermerLightbox, creerSondage,
    renderVoiceBubble, renderVideoBubble, renderSphereInvite,
    getSondageMode, setSondageMode, majLabelAnon, ouvrirModaleSondage, ajouterOptionSondage,
    renderPoll
} from './ui/chat.js';
import { rtcState } from './webrtc/rtcState.js';
import {
    creerConnexionPair, appelerAgent, detecterVoix,
    ajouterBadgeLive, regarderStreamMP, basculerAffichageStream,
    ouvrirStreamChoisi,
    toggleScreenShare, startScreenShare, arreterScreenShare
} from './webrtc/peers.js';
import {
    appliquerSuppressionBruit, stopperFluxAudio,
    activerMicro, toggleMute, toggleDeaf, toggleSuppression,
    quitterVocal, quitterVocalVisuellement,
    dessinerAvatarsVocaux, appliquerVolumeUtilisateur, afficherSliderVolume,
    majBulleVocalRejoint, majBoutonSoundboardHeader,
    toggleSoundboard, jouerSon, ajouterSon,
    afficherSelfHangup, cacherSelfHangup,
    vocalOnSound, vocalOffSound
} from './webrtc/audio.js';
import {
    terminerAppelMPSiActif, majBoutonAppelMP,
    configurerAvatarBandeau, mettreAJourAvatarsBandeau,
    afficherPastilleSortante, cacherPastilleSortante,
    afficherModalEntrant, cacherModalEntrant,
    demarrerCountdownRejoin, arreterCountdownRejoin,
    appelerEnMP, annulerAppelSortant, repondreAppelMP,
    raccrocherMP, revenirAppelMP, demarrerAppelMP, fermerAppelMPDefinitivement,
    ringtoneSound
} from './webrtc/calls.js';
import {
    getPseudoColor, nomAfficheDe,
    assurerInfosAgent,
    ajouterMessageAuDOM, _recalcGroupeNoeud,
    enregistrerSalonSphere, recalculerBadgeSphere, incrementerBadgeSalon,
    resetBadgeSalon, appliquerBadgesSalons,
    _fermerMentionFlyout, _detecterMention, _mentionFlyoutKeydown,
    afficherResultats, fermerResultats,
    sauvegarderDernierVu,
    actionMessage, togglePinsPanel
} from './ui/messages.js';
import {
    gererBulleMP, supprimerBulleSiLue,
    validerRechercheAgent, repondreAmi, annulerDemande,
    ouvrirMenuAmi, switchExtTab, toggleExtMenu,
    actionAgent, afficherOngletSocial, envoyerDemandeAmi, gererActionRelation,
    _majPopoverSpotify, _majActiviteSpotify,
    majParamsProfileCard, initSocialUiElements,
    _renderBanniere,
    ouvrirBanModal, fermerBanModal, confirmerBan,
    ouvrirBanListModal, fermerBanListModal
} from './ui/social.js';
import { initVoiceRecorder } from './ui/voiceRecorder.js';
import {
    appliquerTheme, changerVideoFond, selectionnerVideoFond, _pousserPrefs,
    chargerPreferencesServeur, initPrefsSync,
    appliquerFondPersonnalise, supprimerFondPersonnalise, restaurerFondCustomSiPresent
} from './core/prefs.js';
import {
    ouvrirAccueil, basculerAffichage, updateDashboard, 
    autoDestruction, initDashboard
} from './ui/dashboard.js';
import { 
    demarrerE2EE, ouvrirModaleMesDevicesE2EE, revoquerDeviceE2EE, 
    resetCompletE2EE, abandonnerIdentiteE2EE, validerPINpourSBK, fermerModalPINSBK,
    ouvrirRecuperationPhrase, validerRecuperationPhrase, confirmerPhraseRetro,
    ouvrirModaleAppairage, fermerModaleQR, ouvrirRestaurationQR,
    qrRestoreDepuisTexte, fermerRestaurationQR, ouvrirModaleChangerPIN,
    validerChangementPIN, majIndicateurE2EE, initE2EESync
} from './core/e2ee.js';
import { initSessionLifecycle, initAppBoot } from './auth/session.js';
import { initAfkAuto } from './core/afk-auto.js';
import { initRichPresence, getRichPresenceEnabled, setRichPresenceEnabled } from './core/rich-presence.js';
import { initScreenPicker } from './webrtc/screenPickerModal.js';
import { setEffetsActifs, getEffetsActifs } from './core/messageEffects.js';
import { initModePiP, detacherEnPiP, estEnModePiP } from './core/pip-mode.js';
import { 
    ouvrirGestionRoles, fermerModalRoles, switchRolesTab, 
    miseAJourPermissionLocal, sauvegarderRole, creerNouveauRole, 
    supprimerRoleUI, assignerRoleUI, initRolesSync 
} from './ui/roles.js';
import {
    toggleSearch, fermerRecherche, resetSearch,
    toggleSearchType, lancerRecherche
} from './ui/search.js';
import { lierSpotify, delierSpotify, toggleSpotifyShare } from './ui/spotify.js';
import {
    initDragAndDrop, mettreFichierEnAttente, annulerFichier,
    envoyerFichierAvecTexte, envoyerFichierMPE2EE, envoyerAvatarAuServeur, envoyerIconeSphereAuServeur,
    annulerCropAvatar, confirmerCropAvatar, onAvatarZoomSlider
} from './ui/files.js';
import { 
    rejoindreSalon, ouvrirChatSalon, ouvrirModalSalon, majModalCreation, 
    fermerModalSalon, validerCreationSalon, ouvrirMenuGroupe, debutRenommerGroupeMenu, 
    confirmerSuppressionGroupe, creerGroupeDepuisSalon, toggleGroupe, renommerSalon, 
    validerRenommageSalon, confirmerSuppressionSalon, privatiserSalon, initChannelsSync
} from './ui/channels.js';
import { initChatInput, searchGifs, _majSaisie } from './ui/chatInput.js';
import { toggleLangPicker, updateLangPickers, changerLangue, initLangPickerEvents } from './ui/lang.js';
import { 
    toggleFlyout, toggleStatusPicker, changerStatut, changerStatutAvecDuree, revoquerAppareil,
    revoquerTousAppareils, enregistrerNomAffiche, updateChatHeader, initAccountSync,
    supprimerCompte, toggleEditEmail, changerEmail, toggleEditMotDePasse, changerMotDePasse,
    previewCouleurPseudo
} from './ui/account.js';
import { 
    creerMaSphere, fermerModale, ouvrirSettingsSphere, 
    validerEditSphere, toggleSphereMenu, quitterSphere, confirmerSuppressionSphere 
} from './ui/spheres.js';
import {
    ouvrirChatPrive, rejoindreSphere, nettoyerHeaderGlobal,
    envoyerMPE2EE, send, ouvrirModaleWebhooks,
    creerWebhook, initChatFlowSync,
    armerEphemere, desarmerEphemere, ouvrirEphemere,
} from './ui/chatFlow.js';
import { majSpectateurs, fermerStreamViewer } from './webrtc/streamUI.js';

// On les accroche temporairement à window pour que les vieux onclick HTML continuent de les trouver le temps qu'on nettoie le reste.
window.chaosNotify = chaosNotify;
window.chaosInput = chaosInput;
window.popToast = popToast;
window.escapeHtml = escapeHtml;
window.formatSmartDate = formatSmartDate;
window.formatTime = formatTime;
window.convertirRaccourcisEnEmojis = convertirRaccourcisEnEmojis;
window.state = state;
window.i18n = i18n;
window.t = t;
window.connexion = connexion;
window.deconnexion = deconnexion;
window.procederInscription = procederInscription;
window.validerSetupGoogle = validerSetupGoogle;
window.ouvrirModalReset = ouvrirModalReset;
window.fermerModalReset = fermerModalReset;
window.validerResetPass = validerResetPass;
window.valider2FALogin = valider2FALogin;
window.annuler2FALogin = annuler2FALogin;
window.lancer2FASetup = lancer2FASetup;
window.confirmer2FASetup = confirmer2FASetup;
window.copierCodesSecours = copierCodesSecours;
window.fermer2FASetup = fermer2FASetup;
window.ouvrirDesactiver2FA = ouvrirDesactiver2FA;
window.confirmerDesactiver2FA = confirmerDesactiver2FA;
window.naviguer = naviguer;
window.appliquerNavigation = appliquerNavigation;
window.clicSurSphere = clicSurSphere;
window.majVisibiliteBandeauAppel = majVisibiliteBandeauAppel;
window.majVisibiliteRecherche = majVisibiliteRecherche;
window.toggleMobileChannels = toggleMobileChannels;
window.toggleMobileAgents = toggleMobileAgents;
window.toggleMobileSettings = toggleMobileSettings;
window.closeMobileOverlays = closeMobileOverlays;
window.syncMobileOverlay = syncMobileOverlay;
window.ouvrirModalReport = ouvrirModalReport;
window.fermerModalReport = fermerModalReport;
window.validerReport = validerReport;
window.toggleModerationPanel = toggleModerationPanel;
window.actionModoRejeter = actionModoRejeter;
window.actionModoAvertir = actionModoAvertir;
window.actionModoSupprimer = actionModoSupprimer;
window.ouvrirModalMute = ouvrirModalMute;
window.fermerModalMute = fermerModalMute;
window.validerMute = validerMute;
window.ouvrirModalBootstrap = ouvrirModalBootstrap;
window.fermerModalBootstrap = fermerModalBootstrap;
window.validerBootstrap = validerBootstrap;
window.envoyerChangelog = envoyerChangelog;
window.toggleSettings = toggleSettings;
window.fermerSettings = fermerSettings;
window.ouvrirParamsAvances = ouvrirParamsAvances;
window.fermerParamsAvances = fermerParamsAvances;
window.switchParamsSection = switchParamsSection;
window.chargerPrefsNotif = chargerPrefsNotif;
window.sauvegarderPrefNotif = sauvegarderPrefNotif;
window.getNotifPref = getNotifPref;
window.toggleSidebarMenu = toggleSidebarMenu;
window.majPushChannels = majPushChannels;
window.toggleAgents = toggleAgents;
window.rechercherAgent = rechercherAgent;
window.fermerModaleRecherche = fermerModaleRecherche;
window.toggleRequestInbox = toggleRequestInbox;
window.ouvrirSphereSociale = ouvrirSphereSociale;
window.startScramble = startScramble;
window.ouvrirModaleChoix = ouvrirModaleChoix;
window.ouvrirCreationDirecte = ouvrirCreationDirecte;
window.ouvrirRejoindreDirecte = ouvrirRejoindreDirecte;
window.fermerToutesModales = fermerToutesModales;
window.envoyerCodeInvitation = envoyerCodeInvitation;
window.construireLienInvitation = construireLienInvitation;
window.copierCode = copierCode;
window.copierLienInvitation = copierLienInvitation;
window.chargerDossiers = chargerDossiers;
window._saveDossiers = _saveDossiers;
window._setOrdreSpheres = _setOrdreSpheres;
window.creerDossier = creerDossier;
window.retirerDuDossier = retirerDuDossier;
window.toggleDossier = toggleDossier;
window.scrollToBottom = scrollToBottom;
window.toggleEmojiPicker = toggleEmojiPicker;
window.toggleGifPicker = toggleGifPicker;
window.toggleCustomEmojiPicker = toggleCustomEmojiPicker;
window.initTwemojiPickers = initTwemojiPickers;
window.emojiGifTab = emojiGifTab;
window.toggleEmojiGif = toggleEmojiGif;
window.repondre = repondre;
window.annulerReponse = annulerReponse;
window.toggleReplyMention = toggleReplyMention;
window.commencerEdition = commencerEdition;
window.annulerEdition = annulerEdition;
window.getEditionEnCours = getEditionEnCours;
window.getReponseEnCours = getReponseEnCours;
window.ouvrirMenuReaction = ouvrirMenuReaction;
window.envoyerReaction = envoyerReaction;
window.ouvrirFullEmoji = ouvrirFullEmoji;
window.construireReactionsMessage = construireReactionsMessage;
window.setReactionMessageId = setReactionMessageId;
window.toggleMenuAjout = toggleMenuAjout;
window.fermerMenuAjout = fermerMenuAjout;
window.fermerLightbox = fermerLightbox;
window.renderVoiceBubble = renderVoiceBubble;
window.renderVideoBubble = renderVideoBubble;
window.renderSphereInvite = renderSphereInvite;
window.setSondageMode = setSondageMode;
window.majLabelAnon = majLabelAnon;
window.ouvrirModaleSondage = ouvrirModaleSondage;
window.ajouterOptionSondage = ajouterOptionSondage;
window.renderPoll = renderPoll;
// --- WebRTC bridges ---
window.rtcState = rtcState;
window.creerConnexionPair = creerConnexionPair;
window.appelerAgent = appelerAgent;
window.detecterVoix = detecterVoix;
window.ajouterBadgeLive = ajouterBadgeLive;
window.regarderStreamMP = regarderStreamMP;
window.basculerAffichageStream = basculerAffichageStream;
window.ouvrirStreamChoisi = ouvrirStreamChoisi;
window.toggleScreenShare = toggleScreenShare;
window._majSpectateurs = majSpectateurs;
window.fermerStreamViewer = fermerStreamViewer;
window._onFermerStream = () => {
    socket.emit('stream-je-ne-regarde-plus', { salonChatId: state.salonActuelID });
};
window.startScreenShare = startScreenShare;
window.arreterScreenShare = arreterScreenShare;
window.appliquerSuppressionBruit = appliquerSuppressionBruit;
window.stopperFluxAudio = stopperFluxAudio;
window.activerMicro = activerMicro;
window.toggleMute = toggleMute;
window.toggleDeaf = toggleDeaf;
window.toggleSuppression = toggleSuppression;
window.quitterVocal = quitterVocal;
window.quitterVocalVisuellement = quitterVocalVisuellement;
window.dessinerAvatarsVocaux = dessinerAvatarsVocaux;
window.appliquerVolumeUtilisateur = appliquerVolumeUtilisateur;
window.afficherSliderVolume = afficherSliderVolume;
window.majBulleVocalRejoint = majBulleVocalRejoint;
window.majBoutonSoundboardHeader = majBoutonSoundboardHeader;
window.toggleSoundboard = toggleSoundboard;
window.jouerSon = jouerSon;
window.ajouterSon = ajouterSon;
window.afficherSelfHangup = afficherSelfHangup;
window.cacherSelfHangup = cacherSelfHangup;
window.vocalOnSound = vocalOnSound;
window.vocalOffSound = vocalOffSound;
window.terminerAppelMPSiActif = terminerAppelMPSiActif;
window.majBoutonAppelMP = majBoutonAppelMP;
window.configurerAvatarBandeau = configurerAvatarBandeau;
window.mettreAJourAvatarsBandeau = mettreAJourAvatarsBandeau;
window.afficherPastilleSortante = afficherPastilleSortante;
window.cacherPastilleSortante = cacherPastilleSortante;
window.afficherModalEntrant = afficherModalEntrant;
window.cacherModalEntrant = cacherModalEntrant;
window.demarrerCountdownRejoin = demarrerCountdownRejoin;
window.arreterCountdownRejoin = arreterCountdownRejoin;
window.appelerEnMP = appelerEnMP;
window.annulerAppelSortant = annulerAppelSortant;
window.repondreAppelMP = repondreAppelMP;
window.raccrocherMP = raccrocherMP;
window.revenirAppelMP = revenirAppelMP;
window.demarrerAppelMP = demarrerAppelMP;
window.fermerAppelMPDefinitivement = fermerAppelMPDefinitivement;
window.ringtoneSound = ringtoneSound;
// --- messages.js bridges ---
window.getPseudoColor = getPseudoColor;
window.nomAfficheDe = nomAfficheDe;
window.assurerInfosAgent = assurerInfosAgent;
window.ajouterMessageAuDOM = ajouterMessageAuDOM;
window._recalcGroupeNoeud = _recalcGroupeNoeud;
window.enregistrerSalonSphere = enregistrerSalonSphere;
window.recalculerBadgeSphere = recalculerBadgeSphere;
window.incrementerBadgeSalon = incrementerBadgeSalon;
window.resetBadgeSalon = resetBadgeSalon;
window.appliquerBadgesSalons = appliquerBadgesSalons;
window._fermerMentionFlyout = _fermerMentionFlyout;
window._detecterMention = _detecterMention;
window._mentionFlyoutKeydown = _mentionFlyoutKeydown;
window.afficherResultats = afficherResultats;
window.fermerResultats = fermerResultats;
window.sauvegarderDernierVu = sauvegarderDernierVu;
window.actionMessage = actionMessage;
window.togglePinsPanel = togglePinsPanel;
// --- social.js bridges ---
window.gererBulleMP = gererBulleMP;
window.supprimerBulleSiLue = supprimerBulleSiLue;
window.validerRechercheAgent = validerRechercheAgent;
window.repondreAmi = repondreAmi;
window.annulerDemande = annulerDemande;
window.ouvrirMenuAmi = ouvrirMenuAmi;
window.switchExtTab = switchExtTab;
window.toggleExtMenu = toggleExtMenu;
window.actionAgent = actionAgent;
window.ouvrirBanModal = ouvrirBanModal;
window.fermerBanModal = fermerBanModal;
window.confirmerBan = confirmerBan;
window.ouvrirBanListModal = ouvrirBanListModal;
window.fermerBanListModal = fermerBanListModal;
window._majPopoverSpotify = _majPopoverSpotify;
window._majActiviteSpotify = _majActiviteSpotify;
window.majParamsProfileCard = majParamsProfileCard;
window.monPseudo = window.monPseudo || null;
window.maCouleur = window.maCouleur || null;
window.destinataireID = window.destinataireID || null;
window.salonActuelID = window.salonActuelID || null;
window.ouvrirChatPrive = ouvrirChatPrive;
window.rejoindreSphere = rejoindreSphere;
window.nettoyerHeaderGlobal = nettoyerHeaderGlobal;
window.envoyerMPE2EE = envoyerMPE2EE;
window.send = send;
window.ouvrirModaleWebhooks = ouvrirModaleWebhooks;
window.creerWebhook = creerWebhook;
window.armerEphemere = armerEphemere;
window.desarmerEphemere = desarmerEphemere;
window.ouvrirEphemere = ouvrirEphemere;

// --- bridges app.js → modules (navigation.js / sidebar.js / modals.js) ---
window.rejoindreSphere = rejoindreSphere;
window.ouvrirChatPrive = ouvrirChatPrive;
window.ouvrirAccueil = ouvrirAccueil;
window.nettoyerHeaderGlobal = nettoyerHeaderGlobal;
window.fermerRecherche = fermerRecherche;
window._pousserPrefs = _pousserPrefs;

// --- bridges onclick HTML → app.js (fonctions non encore migrées en module) ---
window.annulerFichier = annulerFichier;
window.autoDestruction = autoDestruction;
window.changerLangue = changerLangue;
window.changerStatut = changerStatut;
window.changerStatutAvecDuree = changerStatutAvecDuree;
window.confirmerPhraseRetro = confirmerPhraseRetro;
window.confirmerSuppressionGroupe = confirmerSuppressionGroupe;
window.confirmerSuppressionSalon = confirmerSuppressionSalon;
window.confirmerSuppressionSphere = confirmerSuppressionSphere;
window.creerGroupeDepuisSalon = creerGroupeDepuisSalon;
window.creerMaSphere = creerMaSphere;
window.creerNouveauRole = creerNouveauRole;
window.creerSondage = creerSondage;
window.creerWebhook = creerWebhook;
window.debutRenommerGroupeMenu = debutRenommerGroupeMenu;
window.dissoudreDossierCtx = dissoudreDossierCtx;
window.enregistrerNomAffiche = enregistrerNomAffiche;
window.fermerGestionnaireTags = fermerGestionnaireTags;
window.fermerModalPINSBK = fermerModalPINSBK;
window.fermerModalRoles = fermerModalRoles;
window.fermerModalSalon = fermerModalSalon;
window.fermerModaleQR = fermerModaleQR;
window.fermerRestaurationQR = fermerRestaurationQR;
window.lancerRecherche = lancerRecherche;
window.ouvrirGestionRoles = ouvrirGestionRoles;
window.ouvrirGestionnaireTags = ouvrirGestionnaireTags;
window.ouvrirModalSalon = ouvrirModalSalon;
window.ouvrirModaleAppairage = ouvrirModaleAppairage;
window.ouvrirModaleChangerPIN = ouvrirModaleChangerPIN;
window.ouvrirModaleWebhooks = ouvrirModaleWebhooks;
window.ouvrirRestaurationQR = ouvrirRestaurationQR;
window.ouvrirSettingsSphere = ouvrirSettingsSphere;
window.privatiserSalon = privatiserSalon;
window.qrRestoreDepuisTexte = qrRestoreDepuisTexte;
window.renommerDossierCtx = renommerDossierCtx;
window.renommerSalon = renommerSalon;
window.revoquerTousAppareils = revoquerTousAppareils;
window.send = send;
window.switchRolesTab = switchRolesTab;
window.toggleFlyout = toggleFlyout;
window.toggleLangPicker = toggleLangPicker;
window.toggleSearch = toggleSearch;
window.toggleSearchType = toggleSearchType;
window.toggleSphereMenu = toggleSphereMenu;
window.toggleStatusPicker = toggleStatusPicker;
window.validerAjoutTag = validerAjoutTag;
window.validerChangementPIN = validerChangementPIN;
window.validerCreationSalon = validerCreationSalon;
window.validerEditSphere = validerEditSphere;
window.validerPINpourSBK = validerPINpourSBK;
window.validerRecuperationPhrase = validerRecuperationPhrase;
window.validerRenommageSalon = validerRenommageSalon;
window.envoyerMPE2EE = envoyerMPE2EE;
window.appliquerTheme = appliquerTheme;

// Ouvre un <input type="color"> positionné près du bouton cliqué
// (évite que le picker natif apparaisse en (0,0) quand l'input est display:none)
window._ouvrirColorPicker = function(inputId, event) {
    const input = document.getElementById(inputId);
    if (!input) return;
    const rect = (event.currentTarget || event.target).getBoundingClientRect();
    input.style.left = Math.min(rect.left, window.innerWidth - 10) + 'px';
    input.style.top  = Math.min(rect.bottom + 2, window.innerHeight - 10) + 'px';
    input.click();
};
window.changerVideoFond = changerVideoFond;
window.selectionnerVideoFond = selectionnerVideoFond;
window.appliquerFondPersonnalise = appliquerFondPersonnalise;
window.supprimerFondPersonnalise = supprimerFondPersonnalise;
window._renderBanniere = _renderBanniere;
window._pousserPrefs = _pousserPrefs;
window.chargerPreferencesServeur = chargerPreferencesServeur;
window.ouvrirAccueil = ouvrirAccueil;
window.autoDestruction = autoDestruction;
window.basculerAffichage = basculerAffichage;
window.updateDashboard = updateDashboard;
window.rendreListeSpheres = rendreListeSpheres;

// E2EE
window.demarrerE2EE = demarrerE2EE;
window.ouvrirModaleMesDevicesE2EE = ouvrirModaleMesDevicesE2EE;
window.revoquerDeviceE2EE = revoquerDeviceE2EE;
window.resetCompletE2EE = resetCompletE2EE;
window.abandonnerIdentiteE2EE = abandonnerIdentiteE2EE;
window.validerPINpourSBK = validerPINpourSBK;
window.ouvrirRecuperationPhrase = ouvrirRecuperationPhrase;
window.validerRecuperationPhrase = validerRecuperationPhrase;
window.confirmerPhraseRetro = confirmerPhraseRetro;
window.ouvrirModaleAppairage = ouvrirModaleAppairage;
window.fermerModaleQR = fermerModaleQR;
window.ouvrirRestaurationQR = ouvrirRestaurationQR;
window.qrRestoreDepuisTexte = qrRestoreDepuisTexte;
window.fermerRestaurationQR = fermerRestaurationQR;
window.ouvrirModaleChangerPIN = ouvrirModaleChangerPIN;
window.validerChangementPIN = validerChangementPIN;
window.majIndicateurE2EE = majIndicateurE2EE;

// SIDEBAR
window.ouvrirMenuDossier = ouvrirMenuDossier;
window.renommerDossierCtx = renommerDossierCtx;
window.changerCouleurDossier = changerCouleurDossier;
window.dissoudreDossierCtx = dissoudreDossierCtx;
window.ouvrirGestionnaireTags = ouvrirGestionnaireTags;
window.fermerGestionnaireTags = fermerGestionnaireTags;
window.validerAjoutTag = validerAjoutTag;
window._setSphereContexte = _setSphereContexte;

// ROLES
window.ouvrirGestionRoles = ouvrirGestionRoles;
window.fermerModalRoles = fermerModalRoles;
window.switchRolesTab = switchRolesTab;
window.miseAJourPermissionLocal = miseAJourPermissionLocal;
window.sauvegarderRole = sauvegarderRole;
window.creerNouveauRole = creerNouveauRole;
window.supprimerRoleUI = supprimerRoleUI;
window.assignerRoleUI = assignerRoleUI;
window.sphereSelectionneeId = null;

//RECHERCHE
window.toggleSearch = toggleSearch;
window.fermerRecherche = fermerRecherche;
window.resetSearch = resetSearch;
window.toggleSearchType = toggleSearchType;
window.lancerRecherche = lancerRecherche;

// Spotify
window.lierSpotify = lierSpotify;
window.delierSpotify = delierSpotify;
window.toggleSpotifyShare = toggleSpotifyShare;

// GESTION FICHIERS
window.mettreFichierEnAttente = mettreFichierEnAttente;
window.annulerFichier = annulerFichier;
window.envoyerFichierAvecTexte = envoyerFichierAvecTexte;
window.envoyerFichierMPE2EE = envoyerFichierMPE2EE;
window.envoyerAvatarAuServeur = envoyerAvatarAuServeur;
window.envoyerIconeSphereAuServeur = envoyerIconeSphereAuServeur;
window.annulerCropAvatar = annulerCropAvatar;
window.confirmerCropAvatar = confirmerCropAvatar;
window.onAvatarZoomSlider = onAvatarZoomSlider;

// LOGIQUE MODALES SALONS
window.rejoindreSalon = rejoindreSalon;
window.ouvrirChatSalon = ouvrirChatSalon;
window.ouvrirModalSalon = ouvrirModalSalon;
window.majModalCreation = majModalCreation;
window.fermerModalSalon = fermerModalSalon;
window.validerCreationSalon = validerCreationSalon;
window.ouvrirMenuGroupe = ouvrirMenuGroupe;
window.debutRenommerGroupeMenu = debutRenommerGroupeMenu;
window.confirmerSuppressionGroupe = confirmerSuppressionGroupe;
window.creerGroupeDepuisSalon = creerGroupeDepuisSalon;
window.toggleGroupe = toggleGroupe;
window.renommerSalon = renommerSalon;
window.validerRenommageSalon = validerRenommageSalon;
window.confirmerSuppressionSalon = confirmerSuppressionSalon;
window.privatiserSalon = privatiserSalon;
window.sphereActuelleID = window.sphereActuelleID || null;
window.nomSphereActuelle = window.nomSphereActuelle || "";

// INPUT
window.searchGifs = searchGifs;
window._majSaisie = _majSaisie;

// PICKER DE LANGUES
window.toggleLangPicker = toggleLangPicker;
window.updateLangPickers = updateLangPickers;
window.changerLangue = changerLangue;

// FLYOUT
window.toggleFlyout = toggleFlyout;
window.toggleStatusPicker = toggleStatusPicker;
window.changerStatut = changerStatut;
window.revoquerAppareil = revoquerAppareil;
window.revoquerTousAppareils = revoquerTousAppareils;
window.enregistrerNomAffiche = enregistrerNomAffiche;
window.updateChatHeader = updateChatHeader;
window.supprimerCompte = supprimerCompte;
window.toggleEditEmail = toggleEditEmail;
window.changerEmail = changerEmail;
window.toggleEditMotDePasse = toggleEditMotDePasse;
window.changerMotDePasse = changerMotDePasse;
window.previewCouleurPseudo = previewCouleurPseudo;

// GESTION DES SPHERES
window.creerMaSphere = creerMaSphere;
window.fermerModale = fermerModale;
window.ouvrirSettingsSphere = ouvrirSettingsSphere;
window.validerEditSphere = validerEditSphere;
window.toggleSphereMenu = toggleSphereMenu;
window.quitterSphere = quitterSphere;
window.confirmerSuppressionSphere = confirmerSuppressionSphere;

// Social
window.afficherOngletSocial = afficherOngletSocial;
window.envoyerDemandeAmi = envoyerDemandeAmi;
window.gererActionRelation = gererActionRelation;
window.genererLien = genererLien;

initVoiceRecorder();
initPrefsSync();
restaurerFondCustomSiPresent();
initDashboard();
initE2EESync();
initSidebarSync();
hookSpheresSockets();
initSessionLifecycle();
initAfkAuto();
initRichPresence();
initScreenPicker();
window.getRichPresenceEnabled = getRichPresenceEnabled;
window.setRichPresenceEnabled = setRichPresenceEnabled;
window._appliquerEffetsMessage = (val) => { setEffetsActifs(val); };
window._setEffetsMessage = (val) => {
    setEffetsActifs(val);
    _pousserPrefs({ effets_message: val });
};
initModePiP();
window.detacherEnPiP = detacherEnPiP;
window.estEnModePiP = estEnModePiP;
initRolesSync();
initDragAndDrop();
initChannelsSync();
initChatInput();
initLangPickerEvents();
initAccountSync();
initChatFlowSync();
initSocialUiElements();

// Déclenchement du DOM quand le boot est prêt :
window.onload = () => {
    initAppBoot();
    // Twemoji sur les pickers : Twemoji.js est un script classique chargé avant
    // les modules ES, donc window.twemoji est dispo ici. On attend un tick pour
    // que emoji-picker-element ait eu le temps de créer son shadow DOM.
    setTimeout(initTwemojiPickers, 300);
};

// ============================================================
//  BOUCLIER ANTI CLIC DROIT GLOBAL
// ============================================================

document.addEventListener('contextmenu', (e) => {
    // Si l'utilisateur clique droit sur l'input pour coller un texte, on le laisse faire !
    if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
        return;
    }
    // Pour tout le reste de l'application, on bloque le menu moche du navigateur.
    e.preventDefault(); 
});

// ==============================================================
// ÉCOUTEUR GLOBAL DE CLICS (Gestionnaire universel de fermeture)
// ==============================================================
document.addEventListener('click', (e) => {
    // 1. Menus contextuels Clic Droit (Dossiers, Sphères, Salons, Messages, Agents)
    const menusContextuels = [
        'folder-context-menu', 'custom-context-menu', 'channel-context-menu', 
        'message-context-menu', 'agent-context-menu', 'sphere-invite-submenu', 
        'ext-profile-dropdown'
    ];
    
    menusContextuels.forEach(id => {
        const menu = document.getElementById(id);
        if (!menu) return;
        
        // Protections spécifiques pour éviter que le menu se ferme au clic sur ses propres options
        if (id === 'message-context-menu' && menu.contains(e.target)) return;
        if (id === 'agent-context-menu' && (menu.contains(e.target) || document.getElementById('sphere-invite-submenu')?.contains(e.target))) return;
        if (id === 'ext-profile-dropdown' && (menu.contains(e.target) || e.target.closest('button[onclick="toggleExtMenu()"]'))) return;
        if (id === 'sphere-invite-submenu' && (menu.contains(e.target) || e.target.closest('#ctx-invite-sphere') || e.target.closest('#ext-btn-invite'))) return;
        
        menu.style.display = 'none';
    });

    // 2. Modales et Dropdowns de paramètres (Fermeture par clic extérieur après 250ms)
    const modalP = document.getElementById('modal-params');
    if (modalP && modalP.style.display !== 'none' && (Date.now() - (window._paramsOpenedAt || 0)) > 250 && !e.target.closest('.params-container')) {
        fermerParamsAvances();
    }
    const pd = document.getElementById('profile-dropdown');
    if (pd && pd.style.display !== 'none' && (Date.now() - (window._settingsOpenedAt || 0)) > 250 && !e.target.closest('#profile-dropdown')) {
        fermerSettings();
    }

    // 3. Inbox des demandes sociales
    const inbox = document.getElementById('request-inbox');
    const trigger = document.getElementById('inbox-trigger');
    if (inbox && trigger && !inbox.contains(e.target) && !trigger.contains(e.target)) {
        inbox.style.display = 'none';
    }

    // 4. Menus de Réactions du Chat (Rapide & Étendu)
    if (!e.target.closest('#quick-reaction-menu') && !e.target.closest('#full-emoji-picker-container') && !e.target.closest('.btn-reagir')) {
        const quickMenu = document.getElementById('quick-reaction-menu');
        const fullMenu = document.getElementById('full-emoji-picker-container');
        if (quickMenu) quickMenu.style.display = 'none';
        if (fullMenu) fullMenu.style.display = 'none';
    }

    // 5. Menu Émojis de la barre de Chat
    const chatContainer = document.getElementById('chat-emoji-picker-container');
    if (chatContainer && chatContainer.style.display === 'block' && !chatContainer.contains(e.target) && !e.target.closest('.icon-btn')) {
        chatContainer.style.display = 'none';
    }

    // 6. Menu des GIFs
    if (window.dejaConnecte) {
        const gifP = document.getElementById('gif-picker');
        if (gifP && !gifP.contains(e.target) && !e.target.closest('.gif-label') && !e.target.closest('#btn-gif')) {
            gifP.style.display = 'none';
        }
    }

    // 7. Flyout de profil utilisateur "épinglé"
    const flyout = document.querySelector('.orb-menu-flyout');
    const avatar = document.getElementById('self-avatar');
    if (flyout && flyout.classList.contains('pinned') && !flyout.contains(e.target) && (!avatar || !avatar.contains(e.target))) {
        flyout.classList.remove('pinned');
    }

    // 8. Sélecteur de statut d'activité
    const statusPicker = document.getElementById('status-picker');
    if (statusPicker && !statusPicker.contains(e.target) && !e.target.closest('button[onclick="toggleStatusPicker(event)"]')) {
        statusPicker.style.display = 'none';
    }
});

// ============================================================
//  FERMETURE RAPIDE (Touche Échap)
// ============================================================
document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
        // 1. Fermer la modale paramètres avancés si ouverte
        const paramsModal = document.getElementById('modal-params');
        if (paramsModal && paramsModal.style.display !== 'none') {
            fermerParamsAvances();
            return;
        }

        // 2. On ferme toutes les modales (elles ont toutes la classe 'modal-overlay')
        const modales = document.querySelectorAll('.modal-overlay');
        modales.forEach(modale => { modale.style.display = 'none'; });

        // 3. On ferme aussi les menus déroulants pour un confort total
        const dropdowns = document.querySelectorAll('.dropdown-menu, .cyber-dropdown');
        dropdowns.forEach(dropdown => { dropdown.style.display = 'none'; });
    }
});

// ===========================
//   MARKDOWN
// ===========================

try {
    if (window.marked && typeof marked.setOptions === 'function') {
        marked.setOptions({ breaks: true, gfm: true });
    }
} catch (_) {}

// Cache les barres d'action pendant une sélection de texte
document.addEventListener('selectionchange', () => {
    const sel = window.getSelection();
    document.body.classList.toggle('text-selecting', !!(sel && sel.toString().length > 0));
});

window.mesAmisActuels = [];
window.mesSpheresActuelles = [];

// Connexion OAuth Electron via polling : injecte le token et valide la session
// directement par socket, sans rechargement de page (évite le SW offline page).
window._loginWithToken = (token) => {
    localStorage.setItem('chaos_token', token);
    socket.emit('valider-session', token);
};  

// HACK DU SHADOW DOM BARRE DE SCROLL EMOJIS => chatInput.js
// GESTION DU THÈME DYNAMIQUE => migré dans core/prefs.js
// LOGIQUE DRAG & DROP DE FICHIERS => files.js
// toggleMenuAjout / fermerMenuAjout → ui/chat.js
// Vocaux E2EE → ui/voiceRecorder.js
// renderVoiceBubble / renderVideoBubble / renderSphereInvite → ui/chat.js
// setSondageMode / majLabelAnon / ouvrirModaleSondage / ajouterOptionSondage → ui/chat.js
// renderPoll / poll helpers / poll-update / poll-mine → ui/chat.js
// lightbox → ui/chat.js
// Gestion fichier & DnD => files.js
// vortex => social.js
// SearchGif => chatInput.js
// Avatars cliquables => ui/social.js
// répondre/édition/réactions → ui/chat.js
// Création et accès nouveaux salons => channels.js
// Collapse des groupes (localStorage) => channels.js
// Drag & drop helpers => channels.js
//WEBHOOKS => chatFlow.js
// appliquerSuppressionBruit, stopperFluxAudio, wakeup-listeners, soundboard,
// toggleSuppression, activerMicro, toggleMute, toggleDeaf, quitterVocal,
// quitterVocalVisuellement, dessinerAvatarsVocaux, appliquerVolumeUtilisateur,
// afficherSliderVolume, vocal-update-global → webrtc/audio.js
// configurerAvatarBandeau, mettreAJourAvatarsBandeau, pastille sortante,
// afficherModalEntrant, cacherModalEntrant, afficherSelfHangup, cacherSelfHangup,
// IIFE flyout, demarrerCountdownRejoin, arreterCountdownRejoin, appelerEnMP,
// annulerAppelSortant, repondreAppelMP, raccrocherMP, revenirAppelMP,
// demarrerAppelMP, fermerAppelMPDefinitivement + socket handlers appel MP
// → webrtc/calls.js
// NETTOYEUR DE NAVIGATION => chatFlow.js
// Fonctions liées à la recherche => ui/search.js
// afficherResultats, fermerResultats, allerAuMessage → ui/messages.js
// assurerInfosAgent, user-render-info, GROUP_WINDOW_MS, _memeJour, _doitGrouper, _recalcGroupeNoeud, ajouterMessageAuDOM → ui/messages.js
// salonUnreadCounts, enregistrerSalonSphere, recalculerBadgeSphere, incrementerBadgeSalon, resetBadgeSalon, appliquerBadgesSalons → ui/messages.js
// Flyout mentions @ : _mentionResults, _fermerMentionFlyout, _detecterMention, _renderMentionFlyout, _choisirMention, _mentionFlyoutKeydown → ui/messages.js
// socket.on('chat message') → ui/messages.js
// socket.on('message-modifie-dom'), socket.on('message-supprime-dom') → ui/messages.js
// socket.on('historique-salon'), socket.on('historique-prive') → ui/messages.js
// _retirerPlaceholdersE2ee, chat-mp-e2ee, chat-mp-e2ee-other-device, chat-mp-e2ee-sent, e2ee-rekey-needed, e2ee-please-refresh-otks → ui/messages.js
// autoClearTyping, user-typing, user-stop-typing, autoClearRecording, user-recording, user-stop-recording → ui/messages.js
// socket.on('user-profile-data') → ui/social.js
// socket.on('liste-agents') → ui/social.js
// actionAgent → ui/social.js
// MP chiffré E2EE => chatFlow.js
// Fonction send => chatFlow.js
// ouvrirMenuAmi → ui/social.js
// switchExtTab → ui/social.js
// _remplirCommuns → ui/social.js
// toggleExtMenu → ui/social.js
// RejoindreSphere => chatFlow.js
// Gestion des rôles => roles.js
// Création/suppression sphères => spheres.js
// DOSSIERS DE SPHÈRES — gérés dans ui/sidebar.js
// Helpers de rendu => ui/sidebar.js
// Demander le lien d'invitation => sidebar.js
// Principes de lectures de bulle => social.js
// supprimerBulleSiLue → ui/social.js
// getPseudoColor → ui/messages.js
// validerRechercheAgent + listener → ui/social.js
// socket.on('voici-les-demandes-en-attente') → ui/social.js
// repondreAmi, annulerDemande, succes-social, demande-ami-mise-a-jour → ui/social.js
// socket.on('voici-tes-amis') → ui/social.js
// Les données du Dashboard => ui/dashboard.js
// ChatPrivé => chatFlow.js
// toggleScreenShare, startScreenShare, arreterScreenShare, webrtc-remove-stream → webrtc/peers.js
// gererBulleMP → ui/social.js
// scrollToBottom + scroll button → ui/chat.js
// Zone de texte qui grandit + retour a la ligne => chatInput.js
// Gestion des input, des mentions, etc. => chatInput.js
// Sélecteur de langue => ui/lang.js
// actionMessage → ui/messages.js
// togglePinsPanel, maj-epingles-dom → ui/messages.js
// MODÉRATION — migrée dans ui/modals.js
// Settings menu déroulant — migré dans ui/modals.js
// Fonctions d'affichage de Spotify => ui/spotify.js
// _spotifyMajUI, spotify sockets, _creerCarteSpotify, _spotifyMajHeartbeat, _majActiviteAgent, _majPopoverSpotify, _majActiviteSpotify, window.message → ui/social.js
// Notifications => migrées dans ui/modals.js
// PRÉFÉRENCES UX EN BDD => migrées dans core/prefs.js
// Appareils connectés => account.js
// majParamsProfileCard → ui/social.js
// E2EE => migré dans js/core/e2ee.js
// socket connexion success => migré dans session.js
// window.onload => session.js
// session valide / invalide => session.js
// premierNonVuId, cleConversation, sauvegarderDernierVu, calculerPremierNonVu, nomAfficheDe → ui/messages.js
// WEBRTC → webrtc/rtcState.js
// creerConnexionPair, appelerAgent, webrtc-offer/answer/ice, audioContext, detecterVoix, ajouterBadgeLive, regarderStreamMP, basculerAffichageStream → webrtc/peers.js
// Elements sidebar et tags de sphères => sidebar.js
// _badgePopup, _showBadgePopup → ui/messages.js
// vocalOnSound, vocalOffSound → webrtc/audio.js
// ringtoneSound → webrtc/calls.js